/* ============================================================
   MOSAIK — CONTROLLER  (UI wiring, collection/pile selection)
   ============================================================ */
Object.assign(window.mosaik, {
  /* Short, null-safe DOM helpers. The desktop markup was rebuilt around the
     two-pane shell (see the .liquid template) and some historical containers
     are gone, so every lookup here must tolerate a missing element. */
  $:function(id){ return document.getElementById(id); },

  /* Tell the UI layer which tool is now active, so it can light the right
     swatch. Fired on every brush change (tile, border/corner colour, eraser). */
  announceTool:function(mode){
    document.dispatchEvent(new CustomEvent('mosaik:tool', { detail:{ mode: mode } }));
  },

  /* ---------- la gomme est un interrupteur ----------
     Outil actif AVANT la gomme, retenu pour pouvoir y revenir : le mode et la
     pastille allumée. Une seule pastille l'est à la fois (markTool éteint celles
     des autres modes), d'où le sélecteur unique. */
  _toolBeforeGomme:null,

  rememberTool:function(){
    this._toolBeforeGomme = {
      mode: this.options.editMode || 'dalles',
      el:   document.querySelector('#mosaik-piles img.sel, #mosaik-edges-list .sel')
    };
  },

  /* Sortie de la gomme : on repose l'outil d'avant. Repli sur le pinceau dalle —
     c'est le mode de départ, et la dalle courante n'a jamais été perdue (la
     gomme ne change aucune couleur). La pastille mémorisée peut avoir disparu
     entre-temps (changement de collection : le nuancier est reconstruit), on
     retombe alors sur la vignette de la dalle courante. */
  exitGomme:function(){
    const prev = this._toolBeforeGomme;
    this._toolBeforeGomme = null;
    const mode = (prev && prev.mode && prev.mode !== 'gomme') ? prev.mode : 'dalles';
    this.options.editMode = mode;
    if(window.MosaikElements) MosaikElements.setActive(mode === 'contour' ? 'bordures' : mode);
    this.announceTool(mode);        // éteint la gomme dans l'UI (voir MosaikUI.markTool)
    let el = prev && prev.el;
    if(el && !document.body.contains(el)) el = null;
    if(!el && mode === 'dalles' && this.options.currentPile) el = this.options.currentPile.el;
    if(el) el.classList.add('sel');
  },

  setPile:function(cur){
    // sélection = classe .sel (cadre bleu + vignette agrandie, voir le CSS du template)
    document.querySelectorAll('#mosaik-piles img').forEach(el => el.classList.remove('sel'));
    cur.classList.add('sel');
    const col = cur.getAttribute('data-collection'), 
          num = cur.getAttribute('data-number');
    this.options.currentPile = this.collections[col].piles[num];
    this.options.solid_pile = this.options.currentPile;
    if(!this.options.checkerboard_piles.length){
      this.options.checkerboard_piles = [this.options.currentPile, this.options.currentPile];
      this.options.checkerboard_counter = 0;
    } else {
      // alterne le slot écrit : 2 choix successifs = couleur 1 puis couleur 2
      const i = 1 - this.options.checkerboard_counter;
      this.options.checkerboard_counter = i;
      this.options.checkerboard_piles[i] = this.options.currentPile;
    }
    this.syncFillChips();
    const rm = this.$('mosaik-piles-remove');
    if(rm) rm.style.border='none';
    // picking a tile colour switches to (and stays in) tile-paint mode
    this.options.editMode = 'dalles';
    if(window.MosaikElements) MosaikElements.setActive('dalles');
    this.announceTool('dalles');
  },

  /* Nom localisé d'une dalle / bordure / angle. */
  pileName:function(p){
    if(!p) return '';
    return p['name_' + this.options.lang] || p.name_fr || p.name_en || '';
  },

  /* Nom COURT d'une dalle, pour l'étiquette sous la pastille du nuancier.
     Les bordures et angles s'appellent déjà « Noir », « Graphite » ; les dalles
     portent le nom commercial complet (« MOSAIK-AERO / DALLES AJOURÉES GARAGE /
     BLEU CIEL », « PVC NOIR »). On ne garde donc que ce qui distingue la dalle :
     le segment après le dernier « / », moins le préfixe de collection s'il est
     répété (PVC, Ultra, Invisible, XL…). Le nom complet reste dans le title. */
  pileShortName:function(p){
    const full = this.pileName(p);
    let s = full.split('/').pop().trim();
    const key = (this.options.currentCollection || '').trim();
    if(key && s.toLowerCase().indexOf(key.toLowerCase() + ' ') === 0)
      s = s.slice(key.length).trim();
    return s || full;
  },

  /* Petites cases de couleur dans « Remplir tout » et « Damier ».
     Elles montrent en permanence la dalle qui sera appliquée : une case pour le
     remplissage uni, deux pour le damier (couleur 1 puis couleur 2). La texture
     réelle de la dalle sert de fond quand elle est connue, sinon sa couleur
     pleine — comme les pastilles du popover mobile.

     Un seul point d'entrée (appelé après CHAQUE changement de pinceau) plutôt
     qu'une écriture inline à chaque endroit : les cases ne peuvent plus rester
     désynchronisées de l'état réel du damier. */
  /* Géométrie des cases, posée EN INLINE ET EN !important par paintChip.

     C'est délibéré, et c'est le seul moyen fiable ici : le CSS global du thème
     Shopify écrase les petits <div> décoratifs placés dans un <button>, et les
     cases disparaissent — exactement le bug que l'ancienne version contournait
     déjà avec `.mosaik-picker { ... display:block!important }`. Une simple règle
     dans le <style> du template ne suffit donc pas : elle marche sur une page
     nue, pas sur le thème. La contrepartie : pour changer l'allure des cases,
     éditer CETTE table, pas seulement le CSS du template. */
  CHIP_CSS: {
    'display':'inline-block', 'position':'static', 'vertical-align':'middle',
    'width':'20px', 'height':'20px', 'border-radius':'50%', 'border':'1px solid #c9d2d6',
    'flex':'0 0 auto', 'box-sizing':'border-box'
  },

  paintChip:function(el, pile){
    if(!el) return;
    const set = (k, v) => el.style.setProperty(k, v, 'important');
    Object.keys(this.CHIP_CSS).forEach(k => set(k, this.CHIP_CSS[k]));
    // aplat seul : plus aucune texture de dalle dans les sélecteurs de couleur
    // (nuancier, cases de remplissage, pastilles mobiles) — voir setCollection
    set('background-color', (pile && pile.color) || '#ccc');
    set('background-image', 'none');
    el.title = this.pileName(pile);
  },

  /* Les `n` cases du bouton `id`. Les <div> déjà présents dans le markup sont
     ADOPTÉS (quelle que soit leur classe : .mosaik-fill-chip aujourd'hui,
     .mosaik-picker dans l'ancien template), et les manquants sont créés — donc
     les cases apparaissent même si le thème déployé et ces scripts ne sont pas
     de la même génération. */
  chipsOf:function(id, n){
    const btn = this.$(id);
    if(!btn) return [];
    const chips = Array.prototype.slice.call(btn.getElementsByTagName('div'), 0, n);
    if(chips.length < n){
      let host = btn.querySelector('.mosaik-fill-chips');
      if(!host){
        host = document.createElement('span');
        host.className = 'mosaik-fill-chips';
        ['display:inline-flex','gap:5px','flex:0 0 auto','align-items:center']
          .forEach(d => { const [k, v] = d.split(':'); host.style.setProperty(k, v, 'important'); });
        btn.appendChild(host);
      }
      while(chips.length < n){
        const d = document.createElement('div');
        host.appendChild(d);
        chips.push(d);
      }
    }
    chips.forEach(c => c.classList.add('mosaik-fill-chip'));
    return chips;
  },

  syncFillChips:function(){
    this.chipsOf('mosaik-solid-mode', 1)
        .forEach(el => this.paintChip(el, this.options.solid_pile));
    const piles = this.options.checkerboard_piles || [];
    this.chipsOf('mosaik-checkerboard-mode', 2)
        .forEach((el, i) => this.paintChip(el, piles[i]));
  },

  /* Le canvas est exporté en PDF via html2canvas (toDataURL) : dessiner une image
     cross-origin sans CORS "taint" le canvas et rend la zone des dalles vide dans le
     PDF. Le cache-buster force une récupération CORS propre, sans resservir une
     version non-CORS déjà mise en cache (fonds CSS des cartes du popup, vignettes
     du récap). */
  corsSrc:function(src){
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'cors=1';
  },

  /* GIF 1×1 transparent : contenu des vignettes du nuancier, qui ne montrent plus
     que leur couleur de fond (voir setCollection). */
  BLANK_PX:'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',

  /* Copie hors écran d'une image de dalle : c'est elle que le canvas dessine.
     Chargée en CORS parce que l'export PDF relit le canvas (toDataURL). */
  loadTexture:function(src){
    const img = new Image();
    img.crossOrigin = 'anonymous';   // avant src, comme pour les vignettes
    img.src = this.corsSrc(src);
    return img;
  },

  setCollection:function(){
    const _this = this, opts = this.options;
    opts.currentCollection = document.getElementById('mosaik-collection').value;
    // collection inconnue = catalogue non chargé (voir le contrôle dans init) :
    // on s'arrête ici plutôt que d'entraîner une cascade d'erreurs illisibles.
    const col = this.collections[opts.currentCollection];
    if(!col) return;
    opts.mosaikWidth = col.width;
    opts.mosaikHeight = col.height;
    // piles : on masque tout le nuancier (les cases des AUTRES collections restent
    // en place, cachées), puis on ré-affiche celles de la collection choisie.
    document.querySelectorAll('#mosaik-piles .mosaik-swatch').forEach(el => { el.style.display = 'none'; });
    col.piles.forEach((p, i) => {
      if(!p.el){
        // NUANCIER = PASTILLE DE COULEUR + NOM DESSOUS, exactement la même case que
        // les bordures et angles (buildEdges) : mêmes classes .mosaik-swatch* , donc
        // même taille, même grille, même sélection. La vignette ne montre plus la
        // texture de la dalle, seulement son aplat. L'élément cliquable reste un
        // <img> — vide, sur un GIF 1×1 transparent — parce que tout le reste le
        // désigne ainsi (`#mosaik-piles img`, la sélection .sel, le popover mobile).
        const cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'mosaik-swatch';
        const img = document.createElement('img');
        img.className = 'mosaik-swatch-dot';
        img.src = this.BLANK_PX;
        img.style.background = p.color || '#ccc';
        img.alt = ''; img.title = this.pileName(p);
        img.setAttribute('data-collection', opts.currentCollection);
        img.setAttribute('data-number', i);
        const lbl = document.createElement('span');
        lbl.className = 'mosaik-swatch-lbl';
        lbl.innerText = this.pileShortName(p);
        cell.appendChild(img); cell.appendChild(lbl);
        cell.title = this.pileName(p);
        cell.addEventListener('click', () => _this.setPile(img));
        document.getElementById('mosaik-piles').appendChild(cell);
        p.el = img; p.cell = cell;
        // Texture du canvas : toujours une copie hors écran chargée en CORS. Même
        // requête qu'avant (la vignette la portait), mais elle n'est plus liée à
        // l'affichage du nuancier.
        p.obj = this.loadTexture(p.img);
      } else {
        (p.cell || p.el).style.display = '';
        // la langue a pu changer depuis la dernière construction
        const lbl = p.cell && p.cell.querySelector('.mosaik-swatch-lbl');
        if(lbl) lbl.innerText = this.pileShortName(p);
      }
    });
    // borders + corners : one palette on the desktop sidebar (see buildEdges)
    opts.currentBorder = false; this.borderAssignments = {};
    opts.currentCorner = false; this.cornerAssignments = {};
    this.buildEdges();
    // The grid starts filled with BLACK (piles[0], via bgPile — see mosaik-render.js),
    // but the default BRUSH is dark grey ("gris foncé") so the visitor can colour in
    // dark grey without having to pick a swatch first. bgPile (background) is kept
    // separate from currentPile (the brush).
    const piles = this.collections[opts.currentCollection].piles;
    opts.bgPile = piles[0];
    this.selectDefaultPile();
  },

  /* Borders and corners are the same colour range sold as two products, and the
     visitor thinks of them as one thing: "the edge of my floor". The sidebar
     therefore shows ONE palette; a colour picks the matching border AND corner,
     and paintAt('contour') applies whichever the clicked cell happens to be.
     A colour that exists on only one of the two lists still works — the other
     stays false and clicking that kind of cell simply does nothing. */
  edgesFor:function(colKey){
    const col = this.collections[colKey] || {},
          lang = this.options.lang,
          brs = col.borders || [], crs = col.corners || [],
          name = o => o['name_' + lang] || o.name_fr || o.name_en || '',
          list = [];
    brs.forEach(b => {
      const c = crs.find(x => name(x) === name(b)) || crs.find(x => x.color === b.color) || null;
      list.push({ label:name(b), color:b.color, border:b, corner:c });
    });
    crs.forEach(c => {
      if(!list.some(e => e.corner === c))
        list.push({ label:name(c), color:c.color, border:null, corner:c });
    });
    return list;
  },

  buildEdges:function(){
    const host = this.$('mosaik-edges-list');
    if(!host) return;                       // markup not emitted (mobile-only page)
    const _this = this;
    host.innerHTML = '';
    this.edgesFor(this.options.currentCollection).forEach(e => {
      // même case que le nuancier des dalles (setCollection) : .mosaik-swatch
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mosaik-swatch';
      const dot = document.createElement('span');
      dot.className = 'mosaik-swatch-dot';
      dot.style.background = e.color || '#ccc';
      const lbl = document.createElement('span');
      lbl.className = 'mosaik-swatch-lbl';
      lbl.innerText = e.label;
      btn.appendChild(dot); btn.appendChild(lbl);
      btn.title = e.label;
      btn.addEventListener('click', () => {
        host.querySelectorAll('.mosaik-swatch').forEach(el => el.classList.remove('sel'));
        btn.classList.add('sel');
        _this.options.currentBorder = e.border || false;
        _this.options.currentCorner = e.corner || false;
        _this.options.editMode = 'contour';
        _this.announceTool('contour');
      });
      host.appendChild(btn);
    });
    if(window.MosaikUI) MosaikUI.refreshCards();
  },

  /* Index of the "gris foncé" tile in the active collection.
     Recherche par nom : d'abord un "gris foncé" explicite, sinon n'importe quel
     gris qui ne soit pas un "gris clair" (la collection AERO n'a qu'un "GRIS"
     tout court). Dernier repli : la 2e dalle de la collection — elles sont toutes
     rangées noir / gris foncé / gris clair / couleurs, donc on ne retombe jamais
     sur le noir (ce qui donnerait noir + noir dans le damier). */
  darkGreyIndex:function(piles){
    const label = p => (p.name_fr || '') + ' ' + (p.name_en || '');
    let i = piles.findIndex(p => /gris[\s-]*fonc|dark[\s-]*gr[ae]y/i.test(label(p)));
    if(i < 0)
      i = piles.findIndex(p =>
        /gris|gr[ae]y/i.test(label(p)) && !/clair|light/i.test(label(p)));
    if(i < 0) i = piles.findIndex(p => /gris|gr[ae]y/i.test(label(p)));
    if(i < 0) i = piles.length > 1 ? 1 : 0;
    return i;
  },

  /* Sélection de départ, appliquée à chaque (re)construction de collection :
     pinceau = gris foncé, damier = [gris foncé, noir].
     Tout est écrit explicitement (plutôt que via setPile) pour que l'état de
     l'UI et celui des options ne puissent pas diverger au chargement. */
  selectDefaultPile:function(){
    const opts = this.options,
          piles = this.collections[opts.currentCollection].piles;
    if(!piles || !piles.length) return;
    const dgPile = piles[this.darkGreyIndex(piles)];
    // pinceau + remplissage uni
    opts.currentPile = opts.solid_pile = dgPile;
    document.querySelectorAll('#mosaik-piles img').forEach(el => el.classList.remove('sel'));
    if(dgPile.el) dgPile.el.classList.add('sel');
    const rm = this.$('mosaik-piles-remove');
    if(rm) rm.style.border = 'none';
    // damier : couleur 1 = gris foncé, couleur 2 = noir.
    // counter = 0 pour que le prochain choix du visiteur écrive le slot 1 (le noir)
    // et laisse le gris foncé en place.
    opts.checkerboard_piles = [dgPile, piles[0]];
    opts.checkerboard_counter = 0;
    this.syncFillChips();
    // on arrive en mode "dalles" : le pinceau gris foncé est utilisable tout de suite
    opts.editMode = 'dalles';
    if(window.MosaikElements) MosaikElements.setActive('dalles');
    this.announceTool('dalles');
  },

  /* Paint at a point given in CANVAS-INTERNAL coordinates. Shared by the desktop
     mouse handlers and the mobile touch layer (mosaik-zoom.js). Returns true if a
     cell was hit. Does not draw — the caller redraws.

     Painting is gated by options.editMode: the visitor can only alter the element
     they picked (tiles / borders / corners). Clicking a border while in tile mode
     does nothing, even if a border colour was selected earlier. 'gomme' erases
     whatever element sits under the cursor.

     Modes: dalles (tiles) | contour (desktop: borders AND corners, one palette)
            bordures / angles (mobile toolbar: one at a time) | gomme (eraser).

     UNE DALLE SUPPRIMÉE (result[idx] === false) EST HORS-JEU : ni le pinceau, ni
     « Remplir tout », ni « Damier » ne la recolorent. Le seul chemin qui la remet
     en jeu est la gomme, qui travaille donc dans les deux sens. */
  /* Sens du geste EN COURS pour la gomme : 'erase' | 'restore' | null.
     Un geste = une seule action, décidée sur la première dalle touchée (pleine →
     on retire, vide → on remet) et tenue jusqu'à la fin du geste. C'est ce qui
     permet de retirer OU de remettre toute une rangée d'un seul trait : le doigt
     qui repasse sur ses propres cases n'annule pas ce qu'il vient de faire.
     Remis à null au début de chaque geste (mousedown / touchstart) — le `click`
     émis à la fin d'un glissé retombe donc sur l'action du geste, où il est sans
     effet, au lieu de rebasculer la dernière dalle. */
  stroke:null,

  paintAt:function(x, y){
    const mode = this.options.editMode || 'dalles';
    let done = false;
    // The cell Path2Ds are built in CSS pixels and the context carries the
    // device-pixel scale (see renderScale in mosaik-render.js): isPointInPath
    // transforms the PATH by that matrix but takes the POINT in raw bitmap
    // coordinates, so the point is the only thing to convert here.
    const k = this.rscale || 1;
    x *= k; y *= k;
    if(mode === 'contour'){
      this.borderPaths.forEach(bp => {
        if(this.ctx.isPointInPath(bp.path, x, y) && this.options.currentBorder){
          this.borderAssignments[bp.idx] = { ...this.options.currentBorder, side: bp.side };
          done = true;
        }
      });
      if(!done) this.cornerPaths.forEach(cp => {
        if(this.ctx.isPointInPath(cp.path, x, y) && this.options.currentCorner){
          this.cornerAssignments[cp.idx] = this.options.currentCorner;
          done = true;
        }
      });
    } else if(mode === 'dalles'){
      this.paths.forEach(p => {
        if(this.result[p.idx] === false) return;        // supprimée : le pinceau glisse dessus
        if(this.ctx.isPointInPath(p.path, x, y)){ this.result[p.idx] = this.options.currentPile; done = true; }
      });
    } else if(mode === 'bordures'){
      this.borderPaths.forEach(bp => {
        if(this.ctx.isPointInPath(bp.path, x, y)){
          if(this.options.currentBorder) this.borderAssignments[bp.idx] = { ...this.options.currentBorder, side: bp.side };
          else delete this.borderAssignments[bp.idx];
          done = true;
        }
      });
    } else if(mode === 'angles'){
      this.cornerPaths.forEach(cp => {
        if(this.ctx.isPointInPath(cp.path, x, y)){
          if(this.options.currentCorner) this.cornerAssignments[cp.idx] = this.options.currentCorner;
          else delete this.cornerAssignments[cp.idx];
          done = true;
        }
      });
    } else if(mode === 'gomme'){
      this.paths.forEach(p => {
        if(!this.ctx.isPointInPath(p.path, x, y)) return;
        const erased = this.result[p.idx] === false;
        // le sens du geste se décide sur la PREMIÈRE dalle touchée (voir stroke)
        if(!this.stroke) this.stroke = erased ? 'restore' : 'erase';
        if(this.stroke === 'restore'){
          if(!erased) return;
          // remise en jeu : la dalle repart de la couleur de fond, comme une
          // dalle neuve, et redevient peignable au pinceau.
          this.result[p.idx] = this.options.bgPile || this.options.currentPile;
        } else {
          if(erased) return;
          this.result[p.idx] = false;
        }
        done = true;
      });
      if(!done) this.borderPaths.forEach(bp => { if(this.ctx.isPointInPath(bp.path, x, y)){ delete this.borderAssignments[bp.idx]; done = true; } });
      if(!done) this.cornerPaths.forEach(cp => { if(this.ctx.isPointInPath(cp.path, x, y)){ delete this.cornerAssignments[cp.idx]; done = true; } });
    }
    // le plan a bougé : la prochaine fin de geste aura quelque chose à retenir
    if(done) this.dirty = true;
    return done;
  },

  /* ---------- historique : une entrée par ACTION ----------

     `dirty` dit qu'un changement attend d'être retenu ; commitHistory() le
     range dans l'historique (mosaik-toolbar.js) et repart à zéro. Il est appelé
     à la FIN de chaque action, une fois qu'elle est appliquée :

       - un clic sur le plan               -> une dalle
       - un glissé (souris ou doigt)       -> le trait entier, une seule entrée
       - « Remplir tout » / « Damier »     -> la zone (ou le plan) en une entrée

     Un geste passe par plusieurs de ces points (le `click` que le navigateur
     émet à la fin d'un glissé, par exemple) : le second commit ne trouve plus
     rien à retenir, et l'historique n'avance donc que d'un cran par action. */
  dirty:false,
  commitHistory:function(force){
    if(force) this.dirty = true;
    if(!this.dirty) return;
    this.dirty = false;
    if(window.MosaikHistory) MosaikHistory.commit();
  },

  /* Nombre de colonnes de dalles du plan. La mise en page fait foi ; le calcul
     direct ne sert qu'avant le premier tracé. */
  gridCols:function(){
    return (this.layout && this.layout.cols)
        || Math.ceil(this.options.width / this.options.mosaikWidth);
  },

  /* Une dalle est-elle concernée par « Remplir tout » / « Damier » ? Sans zone
     sélectionnée, tout le plan l'est (mosaik-select.js). */
  inSelection:function(idx, cols){
    return !window.MosaikSelect || MosaikSelect.has(idx, cols);
  },

  /* Couleur du damier pour une dalle, à partir de sa PLACE DANS LE PLAN — pas de
     son rang dans le remplissage : une zone remplie en damier reste alors dans
     l'alignement du reste du sol. La parité est celle de l'ancien calcul par
     accumulation (dalle 0 = couleur 2), qui lui était impossible à restreindre à
     une zone. */
  checkerPile:function(idx, cols){
    const cb = this.options.checkerboard_piles || [];
    const row = Math.floor(idx / cols), col = idx % cols;
    return ((row + col) % 2 === 0) ? cb[1] : cb[0];
  },

  /* Le double-clic qui ouvre une sélection a déjà peint une dalle avec son
     premier clic : on garde donc de quoi revenir juste avant chaque clic.
     `result` est un tableau de références de dalles — une copie de surface
     suffit, on ne modifie jamais une dalle en place. */
  _clickUndo:null,
  rememberClick:function(){
    this._clickUndo = {
      result: this.result.slice(),
      borders: Object.assign({}, this.borderAssignments),
      corners: Object.assign({}, this.cornerAssignments)
    };
  },
  revertClick:function(){
    const u = this._clickUndo;
    if(!u) return false;
    this.result = u.result;
    this.borderAssignments = u.borders;
    this.cornerAssignments = u.corners;
    this._clickUndo = null;
    return true;
  },

  init:function(grid,opts){
    /* mosaik-data.js porte TOUT le catalogue (collections + traductions). Sans
       lui il n'y a rien à dessiner : on le dit ici, une fois, en nommant le
       fichier — sinon la première erreur venue est un `undefined` au fond d'un
       autre module, qui n'apprend rien (voir les accesseurs de mosaik-core.js).
       Cause la plus fréquente : l'asset mosaik-data2.js n'est pas déployé, ou
       renvoie une erreur / une version tronquée. */
    if(!window.MOSAIK_COLLECTIONS || !window.MOSAIK_L10N){
      console.error('[mosaik] mosaik-data.js (asset mosaik-data2.js) absent ou en échec : '
        + 'ni les collections ni les traductions ne sont chargées. Vérifiez l\'onglet Réseau.');
    }
    this.grid=grid;
    this.ctx=grid.getContext('2d');
    this.setOpts(opts);
    // eraser
    const er = document.createElement('img');
    er.src='//www.mosaik-floor.fr/cdn/shop/t/11/assets/eraser.jpg';
    er.id='mosaik-piles-remove';er.crossOrigin='*';
    er.height=70;
    // hidden: the eraser is now surfaced as the "Gomme" element tab. This element
    // is kept only so the tab and the mobile toolbar can trigger its click handler.
    er.style.display='none';
    er.style.margin='2px';
    (this.$('mosaik-piles-r') || document.body).appendChild(er);
    // A click that belongs to a pan (hand tool armed, or the drag that just
    // ended) must not paint. offsetX/offsetY stay correct while zoomed: they are
    // reported in the element's own untransformed space, which IS the canvas'
    // internal pixel space.
    const panning = () => !!(window.MosaikZoom && MosaikZoom.blocksPaint());
    // un cadre de sélection en cours de tracé fige le pinceau (mosaik-select.js)
    const selecting = () => !!(window.MosaikSelect && MosaikSelect.blocksPaint());
    // un objet pris, armé, ou qu'on vient de manipuler : ce clic-là lui
    // appartient et ne doit pas poser de dalle (mosaik-objects.js)
    const objecting = () => !!(window.MosaikObjects && MosaikObjects.blocksPaint());
    // click
    grid.addEventListener('click', evt => {
      // mémorisé AVANT toute sortie : c'est ce qui permet au double-clic de
      // défaire la dalle peinte par son premier clic (voir revertClick)
      this.rememberClick();
      if(panning() || selecting() || objecting()) return;
      // an active feature layer may intercept clicks (no tile painting meanwhile)
      if(window.MosaikLights && MosaikLights.enabled && MosaikLights.mode === 'on'){
        MosaikLights.handleClick(this, evt);
        this.draw();
        return;
      }
      this.paintAt(evt.offsetX, evt.offsetY);
      this.draw();
      // le clic est une action à lui seul : il entre dans l'historique tout de
      // suite (après un glissé, le geste a déjà été retenu au mouseup — ce
      // commit-ci ne trouve alors rien de neuf)
      this.commitHistory();
    });
    // drag — mousedown ouvre le geste : c'est là que le sens de la gomme se rearme
    grid.addEventListener('mousedown', () => { this.editable = true; this.stroke = null; });
    // fin du geste : le trait entier ne fait qu'une entrée d'historique
    document.addEventListener('mouseup', () => { this.editable = false; this.commitHistory(); });
    grid.addEventListener('mousemove', evt => {
      if(!this.editable)
        return;
      if(panning() || selecting() || objecting()) return;
      // don't drag-paint tiles while a feature layer is capturing input
      if(window.MosaikLights && MosaikLights.enabled && MosaikLights.mode === 'on') return;
      // same gating as a single click: only the selected element is affected
      if(this.paintAt(evt.offsetX, evt.offsetY)) this.draw();
    });
    // inputs
    /* Une cote qui change refait la grille : les objets posés (mosaik-objects.js)
       sont calés en dalles, un plan plus petit les laisserait à cheval sur le
       vide. Ils tombent avec les dalles, comme les éclairages. */
    ['change','keyup'].forEach(ev=>{
      document.getElementById('mosaik-area-width').addEventListener(ev,()=>{ this.result=[]; if(window.MosaikLights){MosaikLights.clear(this);MosaikLights.updateStatus(this);} if(window.MosaikObjects) MosaikObjects.clear(this); this.draw(); });
      document.getElementById('mosaik-area-height').addEventListener(ev,()=>{ this.result=[]; if(window.MosaikLights){MosaikLights.clear(this);MosaikLights.updateStatus(this);} if(window.MosaikObjects) MosaikObjects.clear(this); this.draw(); });
    });
    // collection
    document.getElementById('mosaik-collection').addEventListener('change', e =>{
      // only Aero (Polypropylene) carries cart variant ids
      const atc = this.$('mosaik-add-to-cart');
      if(atc) atc.style.display = (e.target.value === "Polypropylene") ? "" : "none";
      this.options.checkerboard_piles = [];
      this.result=[];
      this.borderAssignments={};
      this.cornerAssignments={};
      if(window.MosaikLights){ MosaikLights.clear(this); MosaikLights.updateStatus(this); }
      // les objets posés référencent une couleur DE CETTE gamme-ci et une taille
      // de dalle : ils repartent avec elle, comme le reste du dessin
      if(window.MosaikObjects){ MosaikObjects.clear(this); MosaikObjects.pileIdx = null; }
      this.setCollection();
      // ... et partout ailleurs, c'est la demande de devis qui prend la place du
      // panier. APRÈS setCollection() : MosaikQuote lit options.currentCollection,
      // que cet appel-là vient justement d'écrire.
      if(window.MosaikQuote) MosaikQuote.syncVisibility();
      if(window.MosaikObjects) MosaikObjects.buildColors();
      if(window.MosaikElements) MosaikElements.refresh();
      if(window.MosaikUI) MosaikUI.refreshCards();
      this.draw();
    });
    /* Les deux remplissages ne touchent QUE la zone sélectionnée quand il y en a
       une (double-clic sur le plan, voir mosaik-select.js) ; sans zone, ils
       s'appliquent à tout le sol, comme avant. */
    // solid
    const solidBtn = this.$('mosaik-solid-mode');
    if(solidBtn) solidBtn.addEventListener('click',()=>{
      const cols = this.gridCols();
      // les dalles supprimées restent supprimées (voir paintAt)
      this.result = this.result.map((c, i) =>
        (c === false || !this.inSelection(i, cols)) ? c : this.options.solid_pile);
      this.draw();
      this.commitHistory(true);        // un remplissage = une action annulable
    });
    // checkerboard
    const cbBtn = this.$('mosaik-checkerboard-mode');
    if(cbBtn) cbBtn.addEventListener('click',()=>{
      const cols = this.gridCols();
      this.result = this.paths.map((p, i) => {
        const cur = this.result[i];
        // la case supprimée le reste, mais l'alternance continue de se dérouler
        // sur elle : le damier garde sa géométrie et n'est pas décalé après un trou.
        if(cur === false || !this.inSelection(i, cols)) return cur;
        return this.checkerPile(i, cols);
      });
      this.draw();
      this.commitHistory(true);        // idem : le damier s'annule d'un coup
    });
    // eraser -> enter "gomme" mode: clicks remove whatever element they land on.
    // Colours are kept, so switching back to an element tab resumes that colour.
    // RECLIQUER SUR LE BOUTON EN SORT : la gomme est un interrupteur, pas un
    // aller simple. Sans ça, le seul moyen de reposer la gomme était de choisir
    // une couleur — donc de changer aussi de pinceau, ce que le visiteur ne
    // demandait pas. On revient à l'outil d'avant (dalle ou bordure/angle),
    // pastille allumée comprise.
    er.addEventListener('click',()=>{
      if(this.options.editMode === 'gomme'){ this.exitGomme(); return; }
      this.rememberTool();
      this.options.editMode = 'gomme';
      if(window.MosaikElements) MosaikElements.select('gomme');
      this.announceTool('gomme');
    });
    
    // initial
    this.setCollection();
    this.draw();
  },

  /* Localize the static labels. Every element is optional: the desktop shell and
     the mobile toolbar emit different subsets of this markup. */
  setOpts:function(opts){
    Object.assign(this.options,opts);
    const txt = (id, key) => { const el = this.$(id); if(el) el.innerText = this.getText(key); };
    const inner = (id, key) => {
      const el = this.$(id);
      if(el && el.getElementsByTagName('span')[0])
        el.getElementsByTagName('span')[0].innerText = this.getText(key);
    };
    txt('mosaik-width-m',  'Width');
    txt('mosaik-length-m', 'Length');
    inner('mosaik-solid-mode',        'Fill all');
    inner('mosaik-checkerboard-mode', 'Checkerboard');
    txt('mosaik-pdf-btn',     'PDF');
    txt('mosaik-add-to-cart', 'Add to cart');
    txt('mosaik-quote-btn',   'Request a quote');
    // La ligne « entrée » est composée dans le markup : une flèche, le texte, une
    // flèche. On n'écrit donc QUE le texte (les flèches de la chaîne traduite,
    // héritée de l'ancienne mise en page, sont retirées) — sinon innerText sur le
    // conteneur effacerait les deux <span> des flèches.
    const ent = this.$('mosaik-entrance-text');
    if(ent) ent.innerText = this.getText('↑↑↑ Garage entrance ↑↑↑').replace(/↑/g, '').trim();
    const bt = document.querySelector('#mosaik-borders .mosaik-opts-title');
    if(bt) bt.innerText = this.getText('Borders')+':';
    const ct = document.querySelector('#mosaik-corners .mosaik-opts-title');
    if(ct) ct.innerText = this.getText('Corners')+':';
  },
});

/* ---- bootstrap: run once the DOM is ready ---- */
document.addEventListener('DOMContentLoaded', function(){
    let nav_lang = navigator.language;
    nav_lang = nav_lang.indexOf('en') > -1 || nav_lang.indexOf('it') > -1 || nav_lang.indexOf('de') > -1 || nav_lang.indexOf('es') > -1 ? 'en' : 'fr';

    // Desktop shell FIRST: it fixes the height of the two panes, and the very
    // first draw() below measures the left pane to size the plan.
    if(window.MosaikUI) MosaikUI.setLayout();

    mosaik.init(document.getElementById('mosaik'), { lang: nav_lang, fill: 'image' });

    // desktop shell wiring (collapsible cards, details drawer, undo/redo, total)
    if(window.MosaikUI) MosaikUI.setupUI(mosaik);

    // optional feature layer UI (only present when emitted server-side)
    if(window.MosaikLights) MosaikLights.setupUI(mosaik);

    // objets à glisser sur le plan : emplacements véhicule + accessoires
    if(window.MosaikObjects) MosaikObjects.setupUI(mosaik);

    // template library UI (only present when emitted server-side)
    if(window.MosaikTemplates) MosaikTemplates.setupUI(mosaik);

    // user-saved designs UI (save button + "my designs" list)
    if(window.MosaikMyTemplates) MosaikMyTemplates.setupUI(mosaik);

    // historique annuler / refaire (mosaik-toolbar.js)
    if(window.MosaikHistory) MosaikHistory.setup(mosaik);

    // desktop element selector (pick tiles/borders/corners, then a colour)
    if(window.MosaikElements) MosaikElements.setupUI(mosaik);

    // touch pinch-zoom / pan / finger-paint on the canvas (mobile)
    if(window.MosaikZoom) MosaikZoom.setup(mosaik);

    // sélection d'une zone du plan (double-clic) — après le zoom : elle l'interroge
    if(window.MosaikSelect) MosaikSelect.setup(mosaik);

    // les deux « ? » : le guide de la page et la fiche de chaque menu
    if(window.MosaikHelp) MosaikHelp.setup(mosaik);

    // demande de devis : le CTA des gammes sans panier (mosaik-quote.js).
    // AVANT le popup de collection, dont le change doit trouver le bouton déjà
    // câblé pour le montrer ou le cacher.
    if(window.MosaikQuote) MosaikQuote.setup(mosaik);

    // collection chooser popup (+ ?collection= URL param). Runs last so its
    // change dispatch reaches the handlers wired above.
    if(window.MosaikCollection) MosaikCollection.setup(mosaik);

    // Add to cart (logic lives in mosaik-cart.js)
    const atc = document.getElementById('mosaik-add-to-cart');
    if(atc) atc.addEventListener('click', () => mosaik.addToCart());

    // PDF export (logic lives in mosaik-pdf.js)
    const pdfBtn = document.getElementById('mosaik-pdf-btn');
    if(pdfBtn) pdfBtn.addEventListener('click', () => MosaikPdf.export());
});
